import {getNotifications} from '../../reducers/state';

export {NotificationPanelButtonContainer as NotificationPanelButton} from  './NotificationPanelButtonContainer';

export function getNoteState(rootState) {
  const noteState = getNotifications(rootState);
  return {
    showButton: noteState.showButton,
    size: noteState.size,
    state: noteState.state,
  };
}



// WEBPACK FOOTER //
// ./src/js/system/components/NotificationPanelButton/index.js